import { Role } from './role';

export class User {
  id: number;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  avatar: string;
  role: Role;
  token?: string;
  // Login da loja por telefone (CON-3683). Sem `origem` o login e o do Google.
  origem?: 'google' | 'telefone';
  telefone?: string;
}
